import TopPick from "../TopPick";

const Image = ({
  imageSrc,
  alt,
  topPicks,
}: {
  imageSrc: string;
  alt: string;
  topPicks?: boolean;
}) => (
  <div className="lc-relative">
    <img src={imageSrc} alt={alt} class="lc-w-full lc-h-48 lc-object-cover" />
    {topPicks && <TopPick />}
  </div>
);

export default Image;
